export class Config {
    

      protected readonly BASE_URL_API = "https://joytogive-api.worldvision.org.ph/api/";
      protected readonly BASE_URL_API_WEBSITE = "https://joytogive-api.worldvision.org.ph/api/website/";
    
    constructor(){
        
    }
}